"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotAuthMenu = void 0;
var NotAuthMenu_1 = require("./NotAuthMenu");
Object.defineProperty(exports, "NotAuthMenu", { enumerable: true, get: function () { return __importDefault(NotAuthMenu_1).default; } });
